async function handleLogoutRedirection(redirect_uri) {
    const returnURL = sessionStorage.getItem('return_url');
    if (returnURL) {
        sessionStorage.removeItem('return_url');
        window.location.href = returnURL;
        return;
    }
    const logoutLinks = document.querySelectorAll('.logout');
    logoutLinks.forEach(logoutLink => {
        logoutLink.addEventListener('click', function (event) {
            const logoutLink = event.target.closest("a[href='/account/logout']");
            if (logoutLink) {
                event.preventDefault();
                sessionStorage.setItem('redirectToPrint', 'true');
                window.location.href = '/account/logout';
                return;
            }
        });
    });
    if (window.location.pathname === '/' && sessionStorage.getItem('redirectToPrint') === 'true') {
        sessionStorage.removeItem('redirectToPrint');
        const params = new URLSearchParams({
            'Referrer': 'SC',
            'redirect_uri': redirect_uri
        });
        window.location.href =  `${window.ENV.ragnarok_user_endpoint}/sso/logout?${params.toString()}`;
    }
}

